<template lang="pug">
b-row
    b-col.threedview_wrapper(sm=9)
        div(id="viewport3d")
    b-col(sm=3)
        p(class="panel-heading text-center font-weight-bold" style="margin-bottom: 2em") Display Settings
        .form-horizontal
            div.form-group.row
                label.col-sm-4.control-label(for="styleSelect" style="text-align: left") Style
                    span.fa.fa-question-circle( data-toggle="tooltip" data-placement="top"
                        title="View the structure in different presentation styles")
                div.col-sm-8
                    select.form-control.input-sm(id="styleSelect" @change="changeRepresentationStyle()"
                        v-model="representationStyle")
                        option(value="backbone") Backbone
                        option(value="surface") Surface
                        option(value="cartoon") Cartoon
                        option(value="spacefill") Spacefill
                        option(value="licorice") Licorice
            div.form-group.row
                label.col-sm-4.control-label(for="colorSchemeSelect" style="text-align: left") Color
                    span(class="fa fa-question-circle" data-toggle="tooltip" data-placement="top"
                        title="Color the structure in different schemes")
                div.col-sm-8
                    select.form-control.input-sm(id="colorSchemeSelect" v-model="colorScheme" @change="colorSchemeChange()")
                        option(value="residueindex") Rainbow
                        option(value="chainindex") By Chain
                        //- option(value="mutation") Mutation in P-sites
                        //- option(value="accesibility") By Accessibility // RSA
                        option(value="sstruc") By Secondary Structure
                        option(value="customModification") Modification Type
            div(v-if="colorScheme == 'customModification'")
                b-form-group(label="Modification types" v-slot="{ ariaDescribedby }")
                    b-form-checkbox(v-model="selectedModType"
                        v-for="mod in modificationTypes"
                        :key="mod.value"
                        :value="mod.value"
                        :class="mod.value"
                        :aria-describedby="ariaDescribedby"
                        name="modification-types"
                        @change="colorModifications"
                        ) {{mod.text}} ({{mod.count}})
</template>

<script>
// import NGL from 'ngl/dist/ngl.esm.js'
let NGL = require('ngl/dist/ngl.esm.js')
const legendColours = {
    'Artefact': '#45516f',
    'Post-translational': '#ff681e',
    'Chemical derivative': '#3abbbb',
    'Multiple,Post-translational': '#ff681e',
    'Other glycosylation': '#5a2a82',
    'Post-translational,Artefact': '#75eeed',
    'Isotopic label,Multiple': '#8a56b2',
    'Post-translational,Isotopic label': '#ff9a4f',
    'Multiple': '#0095a8',
    'O-linked glycosylation': '#6ff9ff',
    'Chemical derivative,Multiple': '#76d275',
    'N-linked glycosylation': '#00701a',
    'Pre-translational': '#fdd835',
    'Synth. pep. protect. gp.': '#870000',
    'Co-translational': '#bb002f'

}
// const blue = '#4e9fe2'
// const red = '#7b241c'
// const lightBlue1 = '#a3cedc'
// const red1 = '#ff0000'

export default {
    name: 'MolecularStructure',
    data() {
        return {
            chain: '',
            pdbId: '',
            stage: '',
            residueList: [],
            mutationList: '',
            colorScheme: 'residueindex',
            representationStyle: 'cartoon',
            modificationTypes: [],
            selectedModType: []
        }
    },
    props: {
        structure: {},
        modifications: []
    },
    watch: {
        structure: {
            immediate: true,
            handler: function(newValue, oldValue) {
                // console.log('Prop changed to: ',newValue,' | from: ', oldValue)
                if (oldValue !== undefined && newValue !== undefined) {
                    this.modTypeList = []
                    this.selectedModType = []
                    this.pdbId = newValue.pdbId
                    this.residueList = newValue.structureModificationsList
                    this.setStageAndLoad()
                    this.modificationTypes = this.setModificationTypes(newValue.structureModificationsList)
                }
            },
            deep: true
        }
    },
    beforeMount: function() {
        if (this.structure !== null && this.structure.size !== 0) {
            console.log('structure', this.structure)
        }
        this.residueList = this.structure.structureModificationsList
        this.modificationTypes = this.setModificationTypes(this.residueList)
        this.pdbId = this.structure['pdbId']
        this.chain = this.structure.chainId
    },
    mounted: function() {
        this.stage = new NGL.Stage('viewport3d', {backgroundColor:'white'} )
        // Handle window resizing
        window.addEventListener( "resize",  event => {
            this.stage.handleResize();
        }, false );
        this.setStageAndLoad()
        this.modificationTypes = this.setModificationTypes(this.residueList)
    },
    methods: {
        setStageAndLoad: function() {
            if (this.stage.compList && this.stage.compList.length !== 0) {
                this.stage.removeAllComponents()
            }
            this.loadFile(this.stage, this.pdbId)
        },
        loadFile: function(stage, pdbId) {
            const url = 'https://files.rcsb.org/view/' + pdbId + '.pdb'
            stage.loadFile(url,{name: pdbId}).then(
                component => {
                    component.addRepresentation('cartoon', {name: 'representation_' + pdbId, colorScheme: 'residueindex'})
                    component.autoView()
                }
            )
        },
        setCustomTooltip() {
            let tooltip = document.createElement("div")
            Object.assign(tooltip.style, {
                display: "none",
                position: "fixed",
                zIndex: 10,
                pointerEvents: "none",
                backgroundColor: "rgba( 0, 0, 0, 0.6 )",
                color: "lightgrey",
                padding: "8px",
                fontFamily: "sans-serif"
            })
            document.body.appendChild(tooltip)
            // remove default hoverPick mouse action
            this.stage.mouseControls.remove("hoverPick")
            // listen to `hovered` signal to move tooltip around and change its text
            this.stage.signals.hovered.add(pickingProxy => {
                if (pickingProxy && (pickingProxy.atom || pickingProxy.bond)) {
                    let atom = pickingProxy.atom || pickingProxy.closestBondAtom
                    let mp = pickingProxy.mouse.position
                    const filteredByPos = this.residueList.filter(el => el.uniprotPosition === atom.resno)
                    let modificationsStr = ''
                    filteredByPos.forEach((value, index) => {
                        modificationsStr += value.unimodModificationName + '(Unimod:'+value.unimodId+')' + (index === filteredByPos.length - 1 ? '' : ', ')
                    })
                    tooltip.innerText = "atom: " + atom.qualifiedName() + (modificationsStr.length > 0 ? '\nModifications: ' + modificationsStr : '')
                    tooltip.style.bottom = window.innerHeight - mp.y + 3 + "px"
                    tooltip.style.left = mp.x + 3 + "px"
                    tooltip.style.display = "block"
                } else {
                    tooltip.style.display = "none"
                }
            })
        },
        setModificationTypes: function(modList) { // TODO move to some kind of util module
            let modTypeList = []
            modList.forEach((element) => {
                if (element.modificationType !== null) { 
                    const index = modTypeList.findIndex(mod => mod.text === element.modificationType)
                    if (index !== -1) {
                        modTypeList[index].count++
                    } else {
                        let temp = {
                            'text': element.modificationType,
                            'value': element.modificationType.replace(/ |,|\.|-/g, '_').toLowerCase(),
                            'count': 1
                        }
                        modTypeList.push(temp)
                        temp = null
                    }
                }
            })
            return modTypeList
        },
        changeRepresentationStyle: function() {
            this.stage.compList[0].removeAllRepresentations()
            this.stage.compList[0].addRepresentation(this.representationStyle, {
                colorScheme: this.customColoring()
            })
        },
        colorModifications: function() {
            let schemeId = ''
            let finalSchemeList = []
            let schemeList = {}
            for (let i in this.residueList) {
                const modValue = this.modificationTypes.find((item) => item.text === this.residueList[i].modificationType)
                if(modValue !== undefined) {
                    if(this.selectedModType.includes(modValue.value)) {
                        if(!Object.prototype.hasOwnProperty.call(schemeList, modValue.value)) {
                            schemeList[modValue.value] = []
                        }
                        schemeList[modValue.value].push(
                            this.residueList[i].uniprotPosition + '-' +
                            this.residueList[i].uniprotPosition + ' and :' + this.residueList[i].chainId
                        )
                    }
                }
            }
            for (const [key, value] of Object.entries(schemeList)) {
                let temp = []
                const modValue = this.modificationTypes.find((item) => item.value === key)
                temp.push(legendColours[modValue.text])
                temp.push(value.join(' or '))
                finalSchemeList.push(temp)
                temp = []
            }
            schemeId = NGL.ColormakerRegistry.addSelectionScheme(finalSchemeList)
            this.stage.getComponentsByName(this.pdbId).addRepresentation(this.representationStyle, {
                colorScheme: schemeId,
                color: schemeId
            })
            // this.stage.compList[0].addRepresentation(this.representationStyle, {
            //     colorScheme: schemeId,
            //     color: schemeId
            // })
            this.setCustomTooltip()
        },

        colorSchemeChange: function() {
            var scheme = this.customColoring()
            if(this.colorScheme === 'customModification' && this.selectedModType.length === 0) {
                this.stage.getComponentsByName(this.pdbId).addRepresentation(this.representationStyle, {sele: 'all', color: 'white'})
            } else {
                this.stage.getComponentsByName(this.pdbId).addRepresentation(this.representationStyle, {
                    colorScheme: scheme,
                    color: scheme
                })
            }
        },

        colorSelectedPart: function(start) {
            if (start !== -1) {
                var schemeId = NGL.ColormakerRegistry.addSelectionScheme([
                    ['#7B241C', start + '-' + start + ' and :' + this.chain]
                ])
                this.stage.compList[0].addRepresentation(
                    this.representationStyle,
                    {
                        sele: 'protein',
                        color: 'grey'
                    }
                )
            }
        },

        customColoring: function() {
            let schemeId = ''
            if (this.colorScheme == 'customModification') {
                this.colorModifications()
            }
            if (this.colorScheme == 'custom') {
                let schemeList = []
                for (let i in this.residueList) {
                    let scheme = this.residueList[i].uniprotPosition + '-' + 
                        this.residueList[i].uniprotPosition + ' and :' + this.chain
                }
                schemeId = NGL.ColormakerRegistry.addSelectionScheme([
                    ['#4E9FE2', schemeList.join(' or ')]
                ])
                return schemeId
            } else if (this.colorScheme == 'mutation') {
                let redList = []
                let lightBlueList = []
                let pSites = []

                for (let i in this.residueList) {
                    pSites.push(this.residueList[i].uniprotPosition)
                }
                for (let i in this.mutationList) {
                    if (pSites.includes(this.mutationList[i].structurePosition)) {
                        if (this.mutationList[i].prediction === 'Deleterious') {
                            redList.push(
                                this.mutationList[i].structurePosition + '-' +
                                this.mutationList[i].structurePosition + ' and :' + this.chain
                            )
                        } else if ( this.mutationList[i].prediction === 'Neutral') {
                            lightBlueList.push(
                                this.mutationList[i].structurePosition + '-' +
                                this.mutationList[i].structurePosition + ' and :' + this.chain
                            )
                        }
                    }
                }
                let red = '0'
                let lightBlue = '0'
                if (redList.length > 0) {
                    red = redList.join(' or ')
                }
                if (lightBlueList.length > 0) {
                    lightBlue = lightBlueList.join(' or ')
                }
                schemeId = NGL.ColormakerRegistry.addSelectionScheme([
                    ['red', red],
                    ['#A3CEDC', lightBlue]
                ])

                return schemeId
            } else if (this.colorScheme == 'accesibility') {
                let lightBlueList = []
                let redList = []
                let orangeList = []

                for (let i in this.residueList) {
                    if (this.residueList[i].accessibleSurfaceArea == 0 && this.residueList[i].buriedSurfaceArea == 0) {
                        redList.push(
                            this.residueList[i].uniprotPosition + '-' +
                            this.residueList[i].uniprotPosition + ' and :' + this.chain
                        )
                    } else if (this.residueList[i].accessibleSurfaceArea > 0 && this.residueList[i].buriedSurfaceArea == 0) {
                        lightBlueList.push(
                            this.residueList[i].uniprotPosition + '-' +
                            this.residueList[i].uniprotPosition + ' and :' + this.chain
                        )
                    } else if (this.residueList[i].accessibleSurfaceArea > 0 && this.residueList[i].buriedSurfaceArea > 0) {
                        orangeList.push(
                            this.residueList[i].uniprotPosition + '-' +
                            this.residueList[i].uniprotPosition + ' and :' + this.chain
                        )
                    }
                }
                let red = '0'
                let lightBlue = '0'
                let orange = '0'
                if (redList.length > 0) {
                    red = redList.join(' or ')
                }
                if (lightBlueList.length > 0) {
                    lightBlue = lightBlueList.join(' or ')
                }
                if (orangeList.length > 0) {
                    orange = orangeList.join(' or ')
                }

                schemeId = NGL.ColormakerRegistry.addSelectionScheme([
                    ['red', red],
                    ['#A3CEDC', lightBlue],
                    ['orange', orange]
                ])
                return schemeId
            } else {
                return this.colorScheme
            }
        },
        toggleSpin: function(el) {
            if (el.checked) {
                this.stage.setSpin([0, 1, 0], 0.005)
            } else {
                this.stage.setSpin(null, null)
            }
        },
        showAllPSites: function() {
            this.colorScheme = 'custom'
            let schema = this.customColoring()
            this.stage.compList[0].addRepresentation(this.representationStyle, {
                colorScheme: schema,
                color: schema
            })
            // return false
        },
        
    }
}
</script>
<style>
#viewport3d {
    width: 100%;
    height: 100%;
}
.threedview_wrapper {
    background-color: #fff;
    display: inline-block;
    text-align: center;
    margin-bottom: 10px;
    height: 650px;
    width: 100%;
}
</style>
